import { render, staticRenderFns } from "./ckeditor.vue?vue&type=template&id=0927a4e8"
import script from "./ckeditor.vue?vue&type=script&lang=js"
export * from "./ckeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports